module.exports = __webpack_public_path__ + "img/ThreePhones2023.e2bddd6e.png";